<fury-scrollbar class="overflow-container">
  <table (matSortChange)="setSort($event)" [dataSource]="dataSource" mat-table matSort multiTemplateDataRows>
    <ng-container *ngFor="let column of columns" matColumnDef="{{column.name}}">
      <th *matHeaderCellDef [disabled]="column.name === 'actions' || !column.sortable" mat-header-cell mat-sort-header>
        <div class="header-content">
          {{ column.title }}
        </div>
        <fury-table-filters (clearFilter)="clearFilter(column.name)"
                            (filterChange)="setFilter(column.name, $event)"
                            [customFiltering]="true"
                            [data]="getMatSelectData(column.data)"
                            [options]="column"
        ></fury-table-filters>
      </th>
      <td *matCellDef="let row" mat-cell>
        <ng-container [ngSwitch]="column.name">
          <ng-container *ngSwitchCase="'created_at'">
            {{ row.created_at | date:'dd-MM-yy HH:mm' }}
          </ng-container>
          <ng-container *ngSwitchCase="'user_id'">
            {{ row.user?.name }}
          </ng-container>
          <ng-container *ngSwitchCase="'history_entry_type_id'">
            {{ row.history_entry_type?.display_name }}
          </ng-container>
          <ng-container *ngSwitchCase="'history_type_id'">
            <div fxLayoutAlign="space-between flex-start">
              <span>{{ row.history_type?.display_name }}</span>
              <ng-container *ngIf="row.sent_email">
                &nbsp;
                <a (click)="previewEmailMessage(row.sent_email);$event.preventDefault()" href="#"><strong>(bekijk e-mail)</strong></a>
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'note'">
            <div *ngIf="row.note" [innerHTML]="removeNewLine(row.note)"></div>
            <div *ngIf="row.sent_email">{{ row.sent_email.recipient }}</div>
          </ng-container>
          <ng-container *ngSwitchCase="'expand'">
            <button (click)="(row.expanded = !row.expanded); $event.stopPropagation()" *ngIf="row.note" mat-icon-button>
              <mat-icon *ngIf="!row.expanded">keyboard_arrow_down</mat-icon>
              <mat-icon *ngIf="row.expanded">keyboard_arrow_up</mat-icon>
            </button>
          </ng-container>
          <ng-container *ngSwitchDefault>
            {{ row[column.name] }}
          </ng-container>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td *matCellDef="let row" [attr.colspan]="visibleColumns.length" mat-cell>
        <div [@detailExpand]="row.expanded ? 'expanded' : 'collapsed'">
          <div class="table-expand-details-content">
            <div *ngIf="row.note" [innerHTML]="row.note"></div>
          </div>
        </div>
      </td>
    </ng-container>

    <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
    <tr *matRowDef="let row; columns: visibleColumns;" class="table-expand-row"
        (click)="row.note ? expandedElement = expandedElement === row ? null : row : null"
        [class.deleted]="row.is_deleted"
        [style.background-color]="row.background_color"
        mat-row></tr>
    <tr *matRowDef="let row; columns: ['expandedDetail']" class="table-expand-details-row" mat-row></tr>

    <div *matNoDataRow class="mat-row mat-row-no-data">
      <div class="mat-cell">Geen data beschikbaar</div>
    </div>
  </table>

  <mat-paginator (page)="setPagination($event)"
                 [length]="dataLength"
                 [pageSizeOptions]="api.pageSizeOptions"
                 [pageSize]="api.pageSize"
                 class="table-paginator"
  ></mat-paginator>
</fury-scrollbar>
<fury-loading-overlay [isLoading]="isLoading"></fury-loading-overlay>
